import fieldType from '@/enums/fieldType'
import InputHelper from '@/plugins/InputHelper'

export default class QueryConditionBuilder {
  constructor () {
    this.condition = {}
  }

  appendBaseFieldCondition(paramName, value){
    if(QueryConditionBuilder.baseFields().includes(paramName) && this.conditionIsValid(value)){
      this.condition[paramName] = value
      return
    }

  }
  appendCondition(field, value){
    if(!this.sourcesIsValid(field,value)){
      return false
    }

    if(field.type==fieldType.RADIO){
      this.appendRadioCondition(field,value)
    }else if(field.type==fieldType.TIME){
      this.appendTimeCondition(field, value)
    }else{
      let paramName=this.buildParamName(field)
      this.condition[paramName]=value
    }
  }

    static baseFields() {
        return ["name", "surname"]
    }

  appendRadioCondition(field,value){
    let condition=InputHelper.getRadioObjectByMatchingValue(field,value)

      if (condition != undefined) {
          let paramName = this.buildParamName(field)
          this.condition[paramName] = condition.key
      }
  }

    buildParamName(field) {
        return "filtr_col_" + field.order
    }


    getConditions() {
        return this.condition
    }

  appendTimeCondition(field,value){
    let timestamp=InputHelper.getTimestampFromHours(value)

      if (timestamp >= 0) {
          let paramName = this.buildParamName(field)
          this.condition[paramName] = timestamp
      }
  }

    conditionIsValid(condition) {
        if (condition != undefined)
            return true
  }

  fieldIsValid(field){
    if(field != undefined && field.order != undefined && InputHelper.isEditableField(field)){
        return true
    }
    return false;
  }

    clearCondition() {
        this.condition = {}
  }

  sourcesIsValid(field, condition){
      return (this.fieldIsValid(field) && this.conditionIsValid(condition))
  }


}
